export const CustomerContract  = {
    async index(is_national, page, per_page, search, sort_by) {
        is_national;
        page;
        per_page;
        search;
        sort_by;
        throw new Error("index_customer not implemented");
    },

    async create(data) {
        data;

        throw new Error("create_customer not implemented");
    },

    async edit(customer_id, data) {
        customer_id;
        data;

        throw new Error("edit_customer not implemented");
    },

    async create_smart_values(customer_id, values) {
        customer_id;
        values;

        throw new Error("create_smart_values_customer not implemented");
    },

    async get_smart_values(customer_id) {
        customer_id;

        throw new Error("get_smart_values_customer not implemented");
    },

    async show(id) { 
        id;

        throw new Error("show_customer not implemented");
    }
}